function getDefaultStorage() {
  // Handle window availability gracefully; prefer window.localStorage over globalThis
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage;
  }
  return globalThis.localStorage;
}

export const appStorage = {
  set(key, value, storage) {
    try {
      const targetStorage = storage ?? getDefaultStorage();
      if (!targetStorage) return;
      const serializedValue = typeof value === 'string' ? value : JSON.stringify(value);
      targetStorage.setItem(String(key), serializedValue);
    } catch (error) {
      // Silently fail if storage is unavailable (e.g., in SSR or private browsing)
      console.warn('appStorage.set failed:', error);
    }
  },

  remove(key, storage) {
    try {
      const targetStorage = storage ?? getDefaultStorage();
      if (!targetStorage) return;
      targetStorage.removeItem(String(key));
    } catch (error) {
      console.warn('appStorage.remove failed:', error);
    }
  },

  clear(storage) {
    try {
      const targetStorage = storage ?? getDefaultStorage();
      if (!targetStorage) return;
      targetStorage.clear();
    } catch (error) {
      console.warn('appStorage.clear failed:', error);
    }
  },

  /**
   * @template T
   * @param {string} key
   * @param {Storage} [storage]
   * @returns {T | undefined}
   */
  get(key, storage) {
    try {
      const targetStorage = storage ?? getDefaultStorage();
      if (!targetStorage) return undefined;
      const rawValue = targetStorage.getItem(String(key));

      if (rawValue === null || rawValue === 'undefined') {
        return undefined;
      }

      try {
        return JSON.parse(rawValue);
      } catch {
        return rawValue;
      }
    } catch (error) {
      // Silently fail if storage is unavailable
      return undefined;
    }
  },
};

export function installLegacyStorageHelpers() {
  const storageScope = typeof window !== 'undefined' ? window : globalThis;
  const storage = storageScope.localStorage;
  const StorageCtor = storageScope.Storage || globalThis.Storage;

  if (!storage || !StorageCtor || !StorageCtor.prototype) {
    return;
  }

  if (typeof StorageCtor.prototype.set !== 'function') {
    StorageCtor.prototype.set = function(key, value) {
      appStorage.set(key, value, storage);
    };
  }

  if (typeof StorageCtor.prototype.get !== 'function') {
    StorageCtor.prototype.get = function(key) {
      return appStorage.get(key, storage);
    };
  }
}

export default installLegacyStorageHelpers;
